// 产品水印管理
import http from "@/jslibs/axios/http";

// 产品水印详情
export const detail = () => http.get("/v1/cms/ProductWater");

// 产品水印更新
export const edit = (data) => http.post("/v1/cms/ProductWater", data);
